import React, { useEffect } from "react";
import min1 from "../../images/min- (1).png";
import min2 from "../../images/min- (3).png";
import min3 from "../../images/min- (2).png";
import redux1 from "../../images/Redux Shop.png";
import redux2 from "../../images/Redux Shop (1).png";
import redux3 from "../../images/Redux Shop (2).png";
import next1 from "../../images/Next IT - Comple (2).png";
import next2 from "../../images/Next IT - Comple (3).png";
import next3 from "../../images/Next IT - Comple (4).png";
import rich1 from "../../images/Rich Table (4).png";
import rich2 from "../../images/Rich Table (5).png";
import rich3 from "../../images/Rich Table (6).png";
import Aos from "aos";
import "aos/dist/aos.css";

const MyWorks = () => {
  useEffect(() => {
    Aos.init({duration: 1000})
  }, [])
  return (
    <div id="Project" className="mt-5 container">
      <div data-aos='fade-up' className="mt-5 text-center">
        <h5 className="text-danger">MY WORKS</h5>
        <br />
        <h2 className="text-white">
          Have A Look <span className="text-warning">At Some Of My Previous <br /> Works</span>
        </h2>
        <div>
          <div class="row row-cols-1 mt-5 row-cols-md-2 g-4">
            <div class="col">
              <div class="card transparent">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img src={min1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={min2} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={min3} class="d-block w-100" alt="..." />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
                <div class="card-body">
                  <h3 class="card-title">Minutes Commerz</h3>
                  <br />
                  <p class="card-text">
                    Professional UI Landing Page is created in React JS and Bootstrap <br />
                    Lets have a look !
                  </p>
                  <div class="d-grid gap-2 col-6 mx-auto">
                    <a href="https://minutes-commerz.web.app/" target="_blank" class="btn btn-danger" type="button">
                      Live Site
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img src={rich1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={rich2} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={rich3} class="d-block w-100" alt="..." />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
                <div class="card-body">
                  <h3 class="card-title mt-3">The Rich Table</h3>
                  <p class="card-text">
                  Are you hungry? Dont worry! The Rich Table is here with their delicious and yummy food that you give inner peace.
                  </p>
                  <div class="d-grid gap-2 col-6 mx-auto">
                    <a href="https://the-rich-table.web.app/" target="_blank" class="btn btn-danger" type="button">
                      Live Site
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img src={next1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={next2} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={next3} class="d-block w-100" alt="..." />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
                <div class="card-body">
                  <h3 class="card-title">Next IT</h3>
                  <br/>
                  <p class="card-text">
                    Next IT is a IT Service related website, where entrepreneur find their <br />
                    reliable IT service. 
                  </p>
                  <div class="d-grid gap-2 col-6 mx-auto">
                    <a href="https://burs-al-arab.web.app/" target="_blank" class="btn btn-danger" type="button">
                      Live Site
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card">
                <div
                  id="carouselExampleControls"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img src={redux1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={redux2} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                      <img src={redux3} class="d-block w-100" alt="..." />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
                <div class="card-body">
                  <h3 class="card-title">Redux Shopping Cart</h3>
                  <br/>
                  <p class="card-text">
                    Redux shopping cart is utilized from React Redux, React JS and SCSS. <br />
                    have a look !
                  </p>
                  <div class="d-grid gap-2 col-6 mx-auto">
                    <a href="https://redux-shop-simple.web.app/" target="_blank" class="btn btn-danger" type="button">
                      Live Site
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-4">
      <h5 className="text-warning ">New Update Coming Soon..</h5>
          <div class="spinner-grow text-primary ms-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
      </div>
    </div>
  );
};

export default MyWorks;
